import React from 'react';

/**
 * BrandProvider component
 * Kept for tree structure compatibility.
 * Brand data is now fed by useRealtimeSocket via Redux — no local listener needed.
 */
const BrandProvider = ({ children }) => {
  return <>{children}</>;
};

export default BrandProvider;
